module.exports = "/_next/static/images/d33739bea2f8a1f21c23d3f230233083-card-xs.png.webp";